import React, { useState } from 'react';
import clsx from 'clsx';
import styles from './ExpenseManager.module.scss';

export default function ExpenseManager({
  items,
  saving,
  error,
  onSave,
  onDelete,
  onClose,
}) {
  const [draft, setDraft] = useState({ name: '' });
  const [formExpanded, setFormExpanded] = useState(false);
  const [searchExpanded, setSearchExpanded] = useState(false);
  const [search, setSearch] = useState('');
  const normalizeSearch = (value) =>
    value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/đ/gi, 'd')
      .toLowerCase();
  const query = normalizeSearch(search.trim());
  const filteredItems = items.filter((item) =>
    normalizeSearch(item.name).includes(query),
  );

  return (
    <div
      className={styles.modalWrapper}
      role="dialog"
      aria-modal="true"
      aria-labelledby="expense-manager-title"
    >
      <div className={styles.overlay} onClick={onClose} />
      <div className={styles.modal}>
        <header className={styles.header}>
          <div>
            <h2 id="expense-manager-title">
              Quản lí khoản chi ({items.length})
            </h2>
            <p>
              Thêm và cập nhật các khoản chi sử dụng trong phiếu chi.
            </p>
          </div>
          <button
            className={styles.closeButton}
            type="button"
            onClick={onClose}
            aria-label="Đóng quản lý khoản chi"
          >
            <i className="fa-solid fa-xmark" aria-hidden="true" />
          </button>
        </header>

        <section className={styles.accordion}>
          <button
            type="button"
            className={styles.accordionToggle}
            aria-expanded={formExpanded}
            aria-controls="expense-form-panel"
            onClick={() => setFormExpanded((expanded) => !expanded)}
          >
            <span>
              {draft.id ? 'Sửa khoản chi' : 'Thêm khoản chi'}
            </span>
            <i
              className={`fa-solid fa-chevron-${
                formExpanded ? 'up' : 'down'
              }`}
              aria-hidden="true"
            />
          </button>
          <div id="expense-form-panel" hidden={!formExpanded}>
            <form
              className={styles.form}
              onSubmit={async (e) => {
                e.preventDefault();
                if (await onSave(draft)) setDraft({ name: '' });
              }}
            >
              <div className={styles.field}>
                <input
                  id="expense-name"
                  className={styles.formInput}
                  placeholder="Nhập tên khoản chi"
                  required
                  maxLength={255}
                  value={draft.name}
                  onChange={(e) =>
                    setDraft({ ...draft, name: e.target.value })
                  }
                />
              </div>

              <div className={styles.formActions}>
                <button
                  className={styles.submitBtn}
                  disabled={saving}
                >
                  {saving
                    ? 'Đang lưu...'
                    : draft.id
                    ? 'Lưu thay đổi'
                    : 'Thêm khoản chi'}
                </button>
                {draft.id && (
                  <button
                    className={styles.cancelButton}
                    disabled={saving}
                    type="button"
                    onClick={() => setDraft({ name: '' })}
                  >
                    Hủy sửa
                  </button>
                )}
              </div>
            </form>
          </div>
        </section>

        <section className={styles.accordion}>
          <button
            type="button"
            className={styles.accordionToggle}
            aria-expanded={searchExpanded}
            aria-controls="expense-search-panel"
            onClick={() => setSearchExpanded((expanded) => !expanded)}
          >
            <span>
              Tìm kiếm khoản chi
              {query ? ` (${filteredItems.length})` : ''}
            </span>
            <i
              className={`fa-solid fa-chevron-${
                searchExpanded ? 'up' : 'down'
              }`}
              aria-hidden="true"
            />
          </button>
          <div id="expense-search-panel" hidden={!searchExpanded}>
            <div className={styles.searchPanel}>
              <input
                id="expense-search"
                type="search"
                className={styles.formInput}
                placeholder="Nhập tên khoản chi cần tìm"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
        </section>
        <ul className={styles.list}>
          {filteredItems.map((item) => (
            <li
              key={item.id}
              className={clsx(styles.row, {
                [styles.editing]: draft.id === item.id,
              })}
            >
              <span className={styles.itemName}>{item.name}</span>
              <div className={styles.rowActions}>
                <button
                  className={styles.editButton}
                  aria-label={`Sửa ${item.name}`}
                  disabled={saving}
                  onClick={() => {
                    setDraft({ id: item.id, name: item.name });
                    setFormExpanded(true);
                  }}
                >
                  <i className="fa-solid fa-pen" aria-hidden="true" />{' '}
                  Sửa
                </button>

                <button
                  className={styles.deleteButton}
                  aria-label={`Xóa ${item.name}`}
                  disabled={saving}
                  onClick={() => onDelete(item.id)}
                >
                  <i
                    className="fa-solid fa-trash"
                    aria-hidden="true"
                  />{' '}
                  Xóa
                </button>
              </div>
            </li>
          ))}

          {!filteredItems.length && (
            <li className={styles.empty}>
              {items.length
                ? 'Không tìm thấy khoản chi phù hợp.'
                : 'Chưa có khoản chi. Thêm khoản chi đầu tiên ở trên.'}
            </li>
          )}
        </ul>
      </div>
    </div>
  );
}
